/**
 * cart-upsell-gift-fix.js
 *
 * Fix: when free-shipping-progress.js auto-adds a free gift, the gift line can
 * become cart.items.first. The complementary/related cart upsell then anchors on
 * the gift product, fetches recommendations for it (none exist), and hides itself.
 *
 * This module keeps the cart-upsell-component anchored on the first NON-GIFT cart
 * item. It reads the gift variant ids from the component's data-free-gift-variant-ids
 * attribute (rendered by snippets/cart-upsell.liquid). It runs after every cart
 * update and after the gift morph, re-pointing data-product-id and nudging the
 * component to reload if it has been left empty/hidden.
 */
(function () {
  var CART_URL = (typeof Theme !== 'undefined' && Theme && Theme.routes && Theme.routes.cart_url)
    ? Theme.routes.cart_url.replace(/\/?$/, '') + '.js'
    : '/cart.js';

  function parseGiftVariantIds(component) {
    var raw = component.getAttribute('data-free-gift-variant-ids') || '';
    return raw.split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function firstNonGiftProductId(items, giftVariantIds) {
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var vid = String(item.variant_id);
      if (giftVariantIds.indexOf(vid) === -1) {
        return String(item.product_id);
      }
    }
    return null;
  }

  function fixAnchor(component) {
    if (!component || !component.isConnected) return;
    var intent = component.dataset.intent;
    // Only complementary/related upsells anchor on a cart product.
    if (intent !== 'complementary' && intent !== 'related') return;

    var giftVariantIds = parseGiftVariantIds(component);
    if (giftVariantIds.length === 0) return;

    fetch(CART_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || !component.isConnected) return;

        var correctId = firstNonGiftProductId(cart.items, giftVariantIds);
        if (!correctId) return;

        var currentId = component.dataset.productId;
        var wasHidden = component.hasAttribute('hidden')
          || component.classList.contains('cart-upsell--hidden')
          || component.style.display === 'none';
        var hasCards = component.querySelectorAll('.cart-upsell-product-card').length > 0;

        // If the component anchored on a gift (wrong id) or got hidden/emptied
        // after the gift add, repoint it and force a fresh load.
        if (currentId !== correctId || wasHidden || !hasCards) {
          component.dataset.productId = correctId;
          // Reset internal flags so init() will actually re-fetch.
          component._isInitialized = false;
          component._isLoading = false;
          // Unhide; syncButtonStatesWithCart for recommendations also unhides,
          // but do it here so an empty render does not stay hidden.
          component.style.display = '';
          component.removeAttribute('hidden');
          component.classList.remove('cart-upsell--hidden');

          if (typeof component.init === 'function') {
            component.init();
          }
        }
      })
      .catch(function () { /* silent: best-effort */ });
  }

  function fixAll() {
    var components = document.querySelectorAll('cart-upsell-component');
    components.forEach(function (c) { fixAnchor(c); });
  }

  // Run after cart updates. free-shipping-progress.js dispatches cart:update
  // (ThemeEvents.cartUpdate) after the gift add+morph. Give the upsell's own
  // handler a moment first, then correct the anchor.
  document.addEventListener('cart:update', function () {
    setTimeout(fixAll, 250);
    setTimeout(fixAll, 700);
  });

  // Also run shortly after load in case the drawer renders with a gift already
  // present (e.g. returning visitor whose cart already qualifies).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(fixAll, 400); });
  } else {
    setTimeout(fixAll, 400);
  }
})();
